import * as React from "react";
import "../../style/fonts.css";
import "./SupportPage.css";
import CtaButton from "../ctaButton/ctaButton";
import { createFollowedUser } from "../../functions/createFollowedUser";
import {
  followUser,
  unfollowUser,
  followWithoutLogIn,
  resetRedirectVars,
} from "../../store/actions/supportActions";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { getVal, firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import translate from "../../translations/i18n";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

export interface Props {
  ownAuth: any;
  followProfile: any;
  followId: any;
  followUser(uid, user): void;
  unfollowUser(uid, user): void;
  followWithoutLogIn(user, userId): void;
  userStatusToFollow: any; //This variable checks if the user is trying to follow a profile without logging in
  supActionErr: any;
  followInfo: any;
  resetRedirectVars(): void;
}

interface State {
  buttonTimeout: boolean;
}
class SupportPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { buttonTimeout: false };

    this.becomeSupporter = this.becomeSupporter.bind(this);
    this.unfollowSupporter = this.unfollowSupporter.bind(this);
    this.becomeSupporterWithoutLogIn = this.becomeSupporterWithoutLogIn.bind(
      this
    );
  }

  becomeSupporter() {
    console.log(this.props.ownAuth.uid);
    const userToFollow = createFollowedUser(
      this.props.followProfile.username,
      this.props.followId,
      this.props.followProfile.start_date,
      this.props.followProfile.avatar
    );

    this.props.followUser(this.props.ownAuth.uid, userToFollow);
  }

  unfollowSupporter() {
    const followedArray = this.props.followInfo;
    const followId = this.props.followId;
    const unFollowUser = followedArray.find(function (element) {
      return element.uid === followId;
    });

    this.props.unfollowUser(this.props.ownAuth.uid, unFollowUser);
  }

  componentDidMount() {
    this.props.resetRedirectVars();
  }

  manageButtonTimeout = (action: () => void) => {
    this.setState({ buttonTimeout: true });
    setTimeout(() => {
      this.setState({ buttonTimeout: false });
    }, 4000);
    action();
  };

  manageSupportButton() {
    if (this.props.followInfo && this.props.followId) {
      const followedArray = this.props.followInfo;
      const followId = this.props.followId;
      const alreadyFollowing = followedArray.find(function (element) {
        return element.uid === followId;
      });
      const alreadyFollowingTwenty =
        (followedArray.length || 0) >= 20 && !alreadyFollowing;
      if (alreadyFollowingTwenty) {
        return (
          <div className="TITLE_3 TOO_MANY_SUPPORTING">
            {translate("SUPPORTER_LIMIT_REACHED")}
          </div>
        );
      }
      if (alreadyFollowing) {
        return (
          <CtaButton
            width={"280px"}
            text={translate("CTA_UNSUPPORT_USER")}
            color={"blue"}
            onClick={() => {
              this.manageButtonTimeout(this.unfollowSupporter.bind(this));
            }}
          />
        );
      } else {
        return (
          <div className="BECOME_SUPPORTER_BTN">
          <CtaButton
            width={"280px"}
            text={translate("CTA_SUPPORT_USER")}
            color={"white"}
            onClick={() => {
              this.manageButtonTimeout(this.becomeSupporter.bind(this));
            }}
          /></div>
        );
      }
    } else
      return (
        <div className="BECOME_SUPPORTER_BTN">
          <CtaButton
            width={"280px"}
            text={translate("CTA_SUPPORT_USER")}
            color={"white"}
            onClick={() => {
              this.manageButtonTimeout(this.becomeSupporter.bind(this));
            }}
          />
        </div>
      );
  }

  becomeSupporterWithoutLogIn() {
    const userToFollow = createFollowedUser(
      this.props.followProfile.username,
      this.props.followId,
      this.props.followProfile.start_date,
      this.props.followProfile.avatar
    );
    this.props.followWithoutLogIn(userToFollow, this.props.followId);
  }

  render() {
    if (this.props.followProfile) {
      if (this.props.ownAuth.isEmpty === true) {
        if (this.props.userStatusToFollow === true) {
          return <Redirect to="/register" push />;
        }
        return (
          <div className="SUPPORT_CONT">
            <Link to="/register">
              <div
                className="BECOME_SUPPORTER_BTN"
                onClick={this.becomeSupporterWithoutLogIn.bind(this)}
              >
                <CtaButton
                  width={"280px"}
                  text={translate("CTA_SUPPORT_USER")}
                  color={"white"}
                />
              </div>
            </Link>
            <div className="ALREADY_LOGIN_CONT">
              <div className="POS_HELPER">
                <Link to="/login" className="TITLE_3">
                  {translate("CTA_ALREADY_SUPPORTER")}
                </Link>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="SUPPORT_CONT">
            {this.state.buttonTimeout && (
              <Loader type="TailSpin" color="white" height={40} width={40} />
            )}
            {!this.state.buttonTimeout && this.manageSupportButton()}
            <div className="ALREADY_LOGIN_CONT">
              <Link to="/overview" className="TITLE_3">
                {translate("CTA_SUPPORT_MANAGEMENT")}
              </Link>
            </div>
          </div>
        );
      }
    } else return null;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    supActionErr: state.sup.followActionError,
    followInfo: getVal(
      state.firestore,
      `data/follow[${ownProps.ownAuth.uid}].users`
    ),
    userStatusToFollow: state.sup.userStatustoFollow,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    followUser: (uid, user) => dispatch(followUser(uid, user)),
    unfollowUser: (uid, user) => dispatch(unfollowUser(uid, user)),
    followWithoutLogIn: (user, userId) =>
      dispatch(followWithoutLogIn(user, userId)),
    resetRedirectVars: () => dispatch(resetRedirectVars()),
  };
};

export default compose<any>(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    { collection: "follow", doc: props.ownAuth.uid },
  ])
)(SupportPage);



// WEBPACK FOOTER //
// ./src/components/Support/SupportPage.tsx